'use client'

import { IS_PROD } from '@/core/constants/is-prod'
import { envService } from '@/core/services/env'
import { useCookiesStore } from '@/core/store/cookies'
import Script from 'next/script'

export const GoogleAnalytics = () => {
  const gaId = envService.get('GOOGLE_ANALYTICS_ID')

  const { cookiesConsented } = useCookiesStore()
  if (!gaId || !IS_PROD || !cookiesConsented) return null

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        strategy='afterInteractive'
        rel='preconnect'
      />
      <Script
        id='ga4'
        strategy='afterInteractive'
        rel='preconnect'
        crossOrigin='anonymous'
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaId}');
        `,
        }}
      />
    </>
  )
}
